import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=8122affc"
import script from "./grid.vue?vue&type=script&lang=js"
export * from "./grid.vue?vue&type=script&lang=js"
import style0 from "./grid.vue?vue&type=style&index=0&id=8122affc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports